import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import config from './config';
import Login from './components/Login';
import Teacher from './components/Teacher';
import Student from './components/Student';
import Admin from './components/Admin';

// Layout component for authenticated users
function MainLayout({ children }) {
  const location = useLocation();
  const userRole = localStorage.getItem('role');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    window.location.href = '/';
  };

  const getSidebarMenu = () => {
    switch (userRole) {
      case 'teacher':
        return [
          { path: '/teacher', icon: 'fas fa-tachometer-alt', label: 'Dashboard', active: location.pathname === '/teacher' },
          { path: '/teacher#syllabi', icon: 'fas fa-book', label: 'Syllabi', active: false },
          { path: '/teacher#videos', icon: 'fas fa-video', label: 'Videos', active: false },
          { path: '/teacher#questions', icon: 'fas fa-question-circle', label: 'Questions', active: false },
          { path: '/teacher#analytics', icon: 'fas fa-chart-bar', label: 'Analytics', active: false },
        ];
      case 'student':
        return [
          { path: '/student', icon: 'fas fa-tachometer-alt', label: 'Dashboard', active: location.pathname === '/student' },
          { path: '/student#courses', icon: 'fas fa-graduation-cap', label: 'My Courses', active: false },
          { path: '/student#progress', icon: 'fas fa-chart-line', label: 'Progress', active: false },
          { path: '/student#assignments', icon: 'fas fa-tasks', label: 'Assignments', active: false },
        ];
      case 'admin':
        return [
          { path: '/admin', icon: 'fas fa-tachometer-alt', label: 'Dashboard', active: location.pathname === '/admin' },
          { path: '/admin#users', icon: 'fas fa-users', label: 'User Management', active: false },
          { path: '/admin#analytics', icon: 'fas fa-chart-bar', label: 'System Analytics', active: false },
        ];
      default:
        return [];
    }
  };

  return (
    <div className="container-fluid mt-4">
      {/* Main Content */}
      {children}
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="app-header bg-primary text-white py-2">
        <div className="container">
          <h5 className="mb-0">
            <i className="fas fa-graduation-cap me-2"></i>
            {config.APP_NAME} - Version {config.VERSION}
          </h5>
        </div>
      </div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/teacher" element={
          <MainLayout>
            <Teacher />
          </MainLayout>
        } />
        <Route path="/student" element={
          <MainLayout>
            <Student />
          </MainLayout>
        } />
        <Route path="/admin" element={
          <MainLayout>
            <Admin />
          </MainLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
